module.exports = __webpack_public_path__ + "fonts/intelo-light.a16239b.woff2";